export const DEV_AUTH_HEADERS =
  process.env.NODE_ENV === "development" && process.env.NEXT_PUBLIC_SERVER_SECRET
    ? {
      "X-Server-Secret": process.env.NEXT_PUBLIC_SERVER_SECRET,
    }
    : {};


